const MOSS = "oklch(0.36 0.06 145)";
const MOSS_2 = "oklch(0.5 0.08 145)";
const MOSS_LIGHT = "oklch(0.7 0.09 145)";
const LEAF = "oklch(0.55 0.13 145)";
const TERRA = "oklch(0.62 0.14 40)";
const TERRA_DEEP = "oklch(0.5 0.13 40)";
const CREAM = "oklch(0.965 0.012 92)";
const PAPER = "oklch(0.99 0.006 90)";
const WOOD = "oklch(0.5 0.06 60)";
const WOOD_DEEP = "oklch(0.4 0.06 60)";
const INK_SOFT = "oklch(0.32 0.04 140)";

export function CameraScanIllustration() {
  return (
    <svg viewBox="0 0 70 64" width="58" height="52">
      <rect x="6" y="32" width="58" height="3" rx="1.5" fill={INK_SOFT} opacity="0.18" />
      <path d="M22 14 L26 8 H44 L48 14 Z" fill={MOSS} />
      <rect x="6" y="14" width="58" height="38" rx="7" fill={MOSS_2} />
      <rect x="6" y="14" width="58" height="6" fill={MOSS} opacity="0.35" />
      <rect x="50" y="20" width="8" height="4" rx="1" fill={CREAM} opacity="0.85" />
      <circle cx="14" cy="22" r="1.5" fill={CREAM} opacity="0.6" />
      <circle cx="35" cy="35" r="13" fill={INK_SOFT} />
      <circle cx="35" cy="35" r="10" fill={MOSS} />
      <circle cx="35" cy="35" r="7" fill={MOSS_LIGHT} />
      <path d="M35 41 C30 40 28 35 31 31 C33 33 33 36 35 38 C37 36 37 33 39 31 C42 35 40 40 35 41 Z" fill={LEAF} />
      <path d="M35 41 L35 33" stroke={MOSS} strokeWidth="0.9" strokeLinecap="round" />
      <circle cx="32" cy="32" r="1.4" fill={PAPER} opacity="0.7" />
    </svg>
  );
}

export function CareTagIllustration() {
  return (
    <svg viewBox="0 0 70 64" width="58" height="52">
      <path d="M35 6 C35 12 30 14 28 18" stroke={WOOD_DEEP} strokeWidth="1.6" fill="none" strokeLinecap="round" />
      <ellipse cx="38" cy="60" rx="18" ry="2" fill={INK_SOFT} opacity="0.18" />
      <path d="M14 18 H44 L60 36 L44 56 H14 Z" fill={TERRA_DEEP} transform="translate(2 2)" opacity="0.35" />
      <path d="M14 18 H44 L60 36 L44 56 H14 Z" fill={TERRA} />
      <path d="M14 18 H44 L60 36 L44 56 H14 Z" stroke={TERRA_DEEP} strokeWidth="1.2" fill="none" />
      <circle cx="20" cy="26" r="3" fill={CREAM} />
      <circle cx="20" cy="26" r="3" stroke={TERRA_DEEP} strokeWidth="0.8" fill="none" />
      <rect x="26" y="32" width="22" height="2.2" rx="1.1" fill={CREAM} opacity="0.95" />
      <rect x="26" y="38" width="18" height="2.2" rx="1.1" fill={CREAM} opacity="0.8" />
      <rect x="26" y="44" width="14" height="2.2" rx="1.1" fill={CREAM} opacity="0.65" />
    </svg>
  );
}

export function SpeciesSearchIllustration() {
  return (
    <svg viewBox="0 0 70 64" width="58" height="52">
      <ellipse cx="38" cy="60" rx="20" ry="2" fill={INK_SOFT} opacity="0.18" />
      <g transform="rotate(38 50 46)">
        <rect x="44" y="42" width="22" height="8" rx="4" fill={WOOD} />
        <rect x="44" y="42" width="22" height="3" rx="1.5" fill={WOOD_DEEP} opacity="0.5" />
        <rect x="42" y="40" width="6" height="12" rx="2" fill={WOOD_DEEP} />
      </g>
      <circle cx="28" cy="28" r="20" fill={MOSS} />
      <circle cx="28" cy="28" r="16.5" fill={PAPER} />
      <path d="M18 36 C16 26 24 18 36 20 C36 30 28 38 18 36 Z" fill={LEAF} />
      <path d="M18 36 L34 22" stroke={MOSS} strokeWidth="1.2" strokeLinecap="round" />
      <path d="M22 30 L28 26" stroke={MOSS} strokeWidth="0.9" strokeLinecap="round" opacity="0.6" />
      <path d="M26 34 L32 26" stroke={MOSS} strokeWidth="0.9" strokeLinecap="round" opacity="0.6" />
      <ellipse cx="22" cy="22" rx="5" ry="2" fill={PAPER} opacity="0.55" transform="rotate(-30 22 22)" />
    </svg>
  );
}
